import './index.css'
import React from 'react'
import { Checkbox as CheckboxBase, FormControlLabel } from '@mui/material'

export default function Checkbox({ name, value, label, handleChange, disabled }: any) {
  return (
    <React.Fragment>
      <div className='checkbox-box'>
        <FormControlLabel
          label={<span className='checkbox-box__label'>{label}</span>}
          className='checkbox-input'
          disabled={disabled}
          control={<CheckboxBase
            name={name}
            checked={value}
            color='success'
            onChange={handleChange} />}
        />
      </div>
    </React.Fragment>
  )
};
